import type { ReactNode } from 'react'
import type { IconTypes } from '@components/utils/Icon'
import Icon from '@components/utils/Icon'
import cn from '@components/utils/cn'

export type EmptyStateProps = {
  iconType: IconTypes
  headline: string
  subtext?: string
  className?: string
  children?: ReactNode
}

export default function EmptyState({ iconType, headline, subtext, className, children }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'tw:flex tw:w-full tw:flex-col tw:items-center tw:gap-4 tw:rounded-md tw:border tw:px-4 tw:py-12',
        className
      )}
    >
      <div className="tw:flex tw:h-14 tw:w-14 tw:items-center tw:justify-center tw:rounded-full tw:bg-primary-50">
        <Icon type={iconType} width={24} height={24} className="tw:text-primary-600" />
      </div>
      <div className="tw:flex tw:flex-col tw:items-center tw:text-center tw:text-black">
        <h3 className="tw:text-lg tw:font-semibold">{headline}</h3>
        {subtext && <p className="tw:text-sm tw:text-gray-cool-500">{subtext}</p>}
      </div>
      {children && <div className="tw:flex tw:w-full tw:flex-wrap tw:justify-center tw:gap-3">{children}</div>}
    </div>
  )
}
